import { render, staticRenderFns } from "./AbandonedCarts2.vue?vue&type=template&id=b11ce19a&scoped=true&"
import script from "./AbandonedCarts2.vue?vue&type=script&lang=js&"
export * from "./AbandonedCarts2.vue?vue&type=script&lang=js&"
import style0 from "./AbandonedCarts2.vue?vue&type=style&index=0&id=b11ce19a&scoped=true&lang=css&"
import style1 from "./AbandonedCarts2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11ce19a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDivider,VExpandTransition,VIcon,VOverlay,VRow,VSelect,VSwitch,VTextField,VTooltip})
